export function extractAndMatch(value, country) {

  if (!value) return false;

  const parts = value.split('-');

  if (parts.length < 3) return false;

  const extractedCountry = parts[1];
  const specialValue = parts[2];

  if (extractedCountry === country) {
    return specialValue;
  }

  return false;

}



// WEBPACK FOOTER //
// ./src/helpers/specialLimitsByCountry.js